import React from 'react';
import type { ITextElement, Token } from '@basis-theory/react-elements';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

import { BasisTheoryTextElement } from './SharedUI';

type BusinessViewProps = {
  token: Token;
  updateToken: (id: string, ref: React.RefObject<ITextElement>) => void;
  isDarkMode: boolean;
  onNext?: () => void;
};

export const BusinessView = ({
  token,
  updateToken,
  isDarkMode,
  onNext,
}: BusinessViewProps) => (
  <div className="flex flex-col h-fit gap-y-f2">
    <BasisTheoryTextElement
      id="name"
      label="Business Legal Name"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="dba"
      label="DBA Name (if applicable)"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="website"
      label="Website"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="phone"
      label="Business Phone Number"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
      type="phone"
    />
    <BasisTheoryTextElement
      id="addressLine1"
      label="Address Line 1"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="addressLine2"
      label="Address Line 2"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="addressCity"
      label="City"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="addressState"
      label="State"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
      type="state"
    />
    <BasisTheoryTextElement
      id="addressZip"
      label="Zip Code"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="industryCode"
      label="Type of Business (NAICS)"
      update={updateToken}
      token={token}
      isDarkMode={isDarkMode}
      type="numeric"
    />
    {onNext != null && <PrimaryButtonV2 onClick={onNext}>Next</PrimaryButtonV2>}
  </div>
);
